import React, { Suspense } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import Spinner from './components/Spinner/Spinner';
import Footer from './components/Footer/Footer';
const Home = React.lazy(() => import('./pages/Home/Home'));
const Products = React.lazy(() => import('./pages/Products/Products'));
const ProductDetail = React.lazy(() => import('./pages/Products/ProductDetail'));
const Cart = React.lazy(() => import('./pages/Cart/Cart'));
const Contact = React.lazy(() => import('./pages/Contact/Contact'));
const Thanks = React.lazy(() => import('./pages/ThanksPage/Thanks'));
const CheckoutOrder = React.lazy(() => import('./pages/CheckoutOrder/CheckoutOrder'));
const Error = React.lazy(() => import('./pages/Error/Error'));
const Media = React.lazy(() => import('./pages/Media/Media'));

class App extends React.Component {
  render() {
    return (
      <>
        <Router>
          <Suspense fallback={<div className="fullpage"><Spinner /></div>}>
            <Switch>
              <Route path="/" exact component={Home} />
              <Route path="/media" exact component={Media} />
              <Route path="/tshirts" exact component={Products} />
              <Route path="/sweatshirts" exact component={Products} />
              <Route path="/gaps" exact component={Products} />
              <Route path="/accesories" exact component={Products} />
              <Route path="/product/:id" exact component={ProductDetail} />
              <Route path="/cart" exact component={Cart} />
              <Route path="/checkout" exact component={CheckoutOrder} />
              <Route path="/thanks" exact component={Thanks} />
              <Route path="/contact" exact component={Contact} />
              <Route path="/error" exact component={Error} />
              <Redirect to="/" />
            </Switch>
          </Suspense>
        </Router>

        <Footer />
      </>
    );
  }
}

export default App;